<!-- 详情 -->
<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <detail-list :col="3">
        <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
        <detail-list-item :term="$t('设备名称')">{{model.meterName}}</detail-list-item>
        <detail-list-item :term="$t('蓄电池剩余电量')">{{model.remainingCharger}}</detail-list-item>
        <detail-list-item :term="$t('蓄电池电压')">{{model.batteryVoltage}}</detail-list-item>
        <detail-list-item :term="$t('蓄电池电流')">{{model.batteryCurrent}}</detail-list-item>
        <detail-list-item :term="$t('蓄电池功率')">{{model.batteryPowerL}}</detail-list-item>
        <detail-list-item :term="$t('负载电压')">{{model.loadVoltage}}</detail-list-item>
        <detail-list-item :term="$t('负载电流')">{{model.loadCurrent}}</detail-list-item>
        <detail-list-item :term="$t('负载功率')">{{model.loadPower}}</detail-list-item>
        <detail-list-item :term="$t('蓄电池状态')">{{[$t('正常'),$t('故障')][model.accumulatorState]}}</detail-list-item>
        <detail-list-item :term="$t('充电设备状态')">{{[$t('正常'),$t('故障')][model.chargeState]}}</detail-list-item>
        <detail-list-item :term="$t('放电设备状态')">{{[$t('正常'),$t('故障')][model.dischargeState]}}</detail-list-item>
        <detail-list-item :term="$t('时间')">{{handleType == 'history'?model.createTime:model.updateTime}}</detail-list-item>
      </detail-list>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        validatorRules: {},
        url: {},
        handleType: ''
      }
    },
    methods: {
      init(row,type){
        this.visible = true;
        this.title = this.$t('详情');
        this.disableSubmit = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.handleType = type
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk() {},
    }
  }
</script>
